module.exports = __webpack_public_path__ + "270effc67296d86f13ab22154b545670.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/category_3.png
// module id = ./assets/images/category_3.png
// module chunks = 0